var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"char-counter-wrapper"},[_c('span',{staticClass:"char-counter",class:{ invalid: _vm.getCurrentCount() > _vm.maxCount }},[_vm._v(_vm._s(_vm.getCurrentCount())+"/"+_vm._s(_vm.maxCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }